export function getCookie(name: string) {
  const cookie: { [k: string]: string } = {}
  document.cookie.split(';').forEach(function (el) {
    const [k, v] = el.split('=')
    if (k && v) {
      cookie[k.trim()] = v
    }
  })
  return cookie['prahapoeticka_' + name]
}

export function setCookie(name: string, value: string | boolean) {
  //cookies set for 30 days
  document.cookie = `prahapoeticka_${name}=${value}; max-age=2592000; Domain=geoportalpraha.cz; SameSite=None; Secure`
}
